import { useEffect, useState, useRef } from 'react';
import { __MB_Analytics } from '../analytics/snowplow';
import { EVENT_SERVICE_NAME } from '@docsapp/constants';
import goodalipi from '../plugins/goodalipi';
import { EVENT_KEYS } from '../analytics/constants';
import { getPlatform } from 'src/utils';

/**
 * Custom hook to handle Snowplow analytics initialization and tracking
 * @returns {Object} { snowplowScript, isSnowplowReady }
 */
export const useSnowplowAnalytics = () => {
  const [snowplowScript, setSnowplowScript] = useState('');
  const [isSnowplowReady, setIsSnowplowReady] = useState(false);
  const hasInitialized = useRef(false);

  // Load Snowplow script from public folder
  useEffect(() => {
    const isProd = process.env.NODE_ENV === 'production';
    const scriptPath = isProd 
      ? '/lib/analytics/snowplow/loader.js'
      : '/lib/analytics/snowplow-staging/loader.js';
    
    fetch(scriptPath)
      .then(response => response.text())
      .then(script => {
        setSnowplowScript(script);
      })
      .catch(error => {
       throw error;
      });
  }, []);

  // Monitor for Snowplow after InitAnalytics renders
  useEffect(() => {
    if (!snowplowScript || hasInitialized.current) return;
    hasInitialized.current = true;
    setIsSnowplowReady(true);
  }, [snowplowScript]);

  // Track user on login - only after Snowplow is ready
  useEffect(() => {
    if (isSnowplowReady) {
      const user = goodalipi.get('user');
      const userId = String(user?.userId ||"");
      const entityId = String(user?.baseProfileData?.entityId ||"");
      if (__MB_Analytics?.trackUserOnLogin) {
        __MB_Analytics.trackUserOnLogin(
          {
            [EVENT_KEYS.PLATFORM]:getPlatform(),
            userId:userId,
            entityId:entityId,
          },
          EVENT_SERVICE_NAME.HRWIN,
        );
      }
    }
  }, [isSnowplowReady]);

  return {
    snowplowScript,
    isSnowplowReady
  };
};
